










 


 






























const node = {
  "kind": "InlineDataFragment",
  "name": "useInitialSafeRoute_meeting"
};

(node ).hash = "8d1d0bd2f17f9023f7b35e7eadd05181";

export default node;
